import React, { ReactElement } from 'react';
import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';
import { TooltipPosition, Tooltip } from 'components/UI/tooltip/tooltip';
import styles from '../_ws-header.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tip?: string | ReactElement;
  tipPosition?: TooltipPosition;
  className?: string;
}

export const WsButton = ({ children, tip, tipPosition, className, ...rest }: Props) => {
  const helpMode = useAppSelector(selectHelpMode);
  return (
    <Tooltip tip={tip} position={tipPosition} showTooltip={helpMode}>
      <button {...rest} className={cm(styles.WsButton, className)}>
        {children}
      </button>
    </Tooltip>
  );
};
